import { useRequestMedicalContext } from "../../Contexts/RequestMedicalTestContext";
import CustomizedProgressBars from "../../Components/LinearDeterminate";
import OtpField from "../../Components/OtpField";
import Button from "../../Components/Button";

function ReqMedical7() {
  const {
    setSelectedOrderIndex,
    setSelectedProcedure,
    setSelectedClinic,
    setSelectedOrder,
    setSelectedDates,
    setSelectedTimes,
    setFullName,
    navigate,
    setOTP,
    otp,
  } = useRequestMedicalContext();

  function handleSubmit() {
    setSelectedOrderIndex();
    setSelectedProcedure([]);
    setSelectedOrder("");
    setSelectedDates({});
    setSelectedTimes({});
    setSelectedClinic();
    setFullName("");
    setOTP("");
    navigate("/request-medical-test/success");
  }
  
  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-center justify-center">
      <div className="w-full sm:w-148 flex-grow">
        <div className="sm:w-148 h-72 bg-white rounded-xl sm:mt-24">
          <div className="grid grid-cols-1 divide-y">
            <div className="text-center font-semibold mb-3 mt-3">
              Request Medical Test
            </div>
            <div className="p-3">
              <CustomizedProgressBars value={100} />
            </div>
          </div>
          <div className="px-4">
            <div className="text-xl font-semibold">
              Let's verify your mobile number
            </div>

            <div className="flex flex-row mt-1">
              <div className=" text-[#60656D]">
                Verify your account by entering the one-time password sent to{" "}
                <span className="text-[#1F2328] font-semibold ml-1">+63</span>
              </div>
            </div>

            <div className="mt-3">
              <OtpField value={otp} onChange={setOTP} />
            </div>

            <div className="flex flex-row mt-3">
              <div className="text-sm text-[#60656D]">
                Didn't get the password?{" "}
                <span className=" text-[#A3A7AB] ml-1 cursor-pointer">
                  Resend (in 30 sec)
                </span>
              </div>
            </div>

            <div className="sm:relative absolute inset-x-0 bottom-0 p-2">
              <Button
                disabled={otp.length < 4}
                className={`w-full sm:w-20 h-10 sm:absolute sm:right-0  ${
                  otp.length < 4 ? `text-[#A3A7AB] bg-[#F6F7F7]` : `text-white`
                }`}
                onClick={handleSubmit}
              >
                Verify
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReqMedical7;
